import React from "react";

export default function CardWithHeader({title, description, afterTitle, bodyClass, children}) {
    return <div className="bg-inverse rounded-card border-tm-gray-300 border shadow-card">
        <div className="px-6 py-4 border-b border-tm-gray-200 flex flex-wrap items-center gap-x-3 mb-5">
            <h2 className="m-0 text-lg font-medium text-tm-gray-900 leading-9">{title}</h2>

            <span className="text-[13px] text-tm-gray-500">{description}</span>

            {!!afterTitle && (
                <div className="ml-auto flex items-center gap-x-2">
                    {afterTitle}
                </div>
            )}
        </div>

        <div className={bodyClass ?? "px-6 pb-6 space-y-6"}>
            {children}
        </div>
    </div>
}